import PersonalInfoContactForm from './PersonalInfoContactForm.component';

export default PersonalInfoContactForm;
